import { Button, Flex, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

const RouteError = () => {
  const { t } = useTranslation();

  return (
    <Flex justify="center" align="center" mih="400px" w="100%" p="md">
      <Stack gap="md" align="center" ta="center" maw={420}>
        <Title order={4}>{t("routeError.title")}</Title>
        <Text size="sm">{t("routeError.message")}</Text>
        <Button onClick={() => window.location.reload()}>
          {t("routeError.action")}
        </Button>
      </Stack>
    </Flex>
  );
};

export default RouteError;
